'use client';
import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

export const MentionsHeader = () => {
  const { t } = useT();
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: '1.75rem',
          color: 'text.primary',
          mb: 1,
          lineHeight: 1.2,
          textAlign: {
            xs: 'center',
            sm: 'left',
          },
        }}
      >
        {t('mentions.title')}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: '0.9375rem',
          color: 'text.secondary',
          lineHeight: 1.5,
          textAlign: {
            xs: 'center',
            sm: 'left',
          },
        }}
      >
        {t('mentions.description')}
      </Typography>
    </Box>
  );
};
